export default __webpack_public_path__ + "static/781-5ff3835417767e739ccd79b0a3536999.gif";